/* eslint-disable no-unused-vars */
import {
  HomeWorkRounded,
  ConnectWithoutContactRounded,
  PermContactCalendarRounded,
  AddLocationAltRounded,
  ReviewsRounded,
} from '@mui/icons-material';
import { styled, Box } from '@mui/material';

export enum TypeTabPort {
  Overview = 'Overview',
  Operations = 'Operations',
  Terminals = 'Terminals',
  TradeTransit = 'Trade & Transit',
  TrafficThroughput = 'Traffic & Throughput',
}

export const TABS_PORT: ITabSetting[] = [
  {
    key: TypeTabPort.Overview,
    label: TypeTabPort.Overview,
    icon: HomeWorkRounded,
    disable: false,
  },
  {
    key: TypeTabPort.Operations,
    label: TypeTabPort.Operations,
    icon: PermContactCalendarRounded,
    disable: false,
  },
  {
    key: TypeTabPort.Terminals,
    label: TypeTabPort.Terminals,
    icon: ConnectWithoutContactRounded,
    disable: false,
  },
  {
    key: TypeTabPort.TradeTransit,
    label: TypeTabPort.TradeTransit,
    icon: AddLocationAltRounded,
    disable: false,
  },
  {
    key: TypeTabPort.TrafficThroughput,
    label: TypeTabPort.TrafficThroughput,
    icon: ReviewsRounded,
    disable: false,
  },
];

export enum IsExportType {
  Import = 0,
  Export = 1,
}

export enum IsLastType {
  Outbound = 0,
  Inbound = 1,
}

// Common Style WhiteBox use in multiple tab
export const StyledWhiteBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius * 2,
  background: theme.palette.background.default,
}));
